export const facultySortHandler = (data) => {
    const designationOrder = {
        "Professor": 1,
        "Associate Professor": 2,
        "Assistant Professor": 3,
        "Lecturer A": 4,
        "Lecturer B": 5,
        "Lecturer C": 6,
    };

    return data?.sort((a, b) => {
        // Compare designations based on custom order
        const orderA = designationOrder[a.designation] || 7; // Default to a higher order if not found
        const orderB = designationOrder[b.designation] || 7;

        if (orderA !== orderB) {
            return orderA - orderB;
        }

        // If designations are the same, sort alphabetically by name
        return a.name.localeCompare(b.name);
    });
};